export const checkOnlyNumber = /^[0-9]+$/;
export const phoneRegex = /^[0-9-]+$/;
